/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateGreetingModelSchema } from "../createOrUpdateGreetingModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданного шаблона
 */
export const postApiGreetings200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Шаблон приветственного экрана уже существует | Ошибка валидации
 */
export const postApiGreetings400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiGreetings401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiGreetings403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiGreetings500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiGreetingsMutationRequestSchema = z.lazy(() => createOrUpdateGreetingModelSchema).describe("Тело запроса")

export const postApiGreetingsMutationResponseSchema = z.lazy(() => postApiGreetings200Schema)